<template>
  <div class="my-download">
    <div class="top-line">
      <div class="top-button" @click="toBatchDel">
        <img
          class="top-icon"
          :src="require('../assets/mine/delete.png')"
          alt=""
        />
        批量删除记录
      </div>
    </div>
    <el-table
      height="calc(100vh - 340px)"
      :data="data"
      style="width: 100%; margin-bottom: 10px"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="序号" width="80" align="center">
        <template slot-scope="scope">{{
          scope.$index + 1 + (page - 1) * 10
        }}</template>
      </el-table-column>
      <el-table-column label="下载文件" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.files.length == 1" style="display: flex">
            <img
              class="file-icon"
              :src="getIconUrl(scope.row.files[0].file_name)"
              alt=""
            />
            {{ scope.row.files[0].file_name }}
          </div>
          <div v-else style="display: flex">
            {{
              scope.row.isPic
                ? `${scope.row.res_title}-图片素材`
                : `${scope.row.res_title}-资源包`
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="res_title"
        label="资源标题"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="created_at"
        label="下载时间"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <div style="display: flex; justify-content: center">
            <div class="small-button" @click="toDetail(scope.row.res_id)">
              前往资源
            </div>
            <div class="small-button-cancel" @click="delRecord(scope.row.id)">
              删除记录
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="float: right"
      background
      @current-change="onPageChange"
      :current-page="page"
      :page-size="10"
      layout="prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import {
  download_list,
  delDownloadRecord,
  delDownloadRecordBatch,
} from '@/api/api'
export default {
  name: 'MyDownload',
  data: () => ({
    data: [],
    page: 1,
    total: 0,
    delIds: [],
  }),
  mounted() {
    this.getDownloadList()
  },
  methods: {
    onPageChange(e) {
      this.page = e
      this.getDownloadList()
    },
    getDownloadList() {
      download_list(this.page).then((res) => {
        res.data.data.list.forEach((item) => {
          if (item.files.length > 1) {
            // 判断是下载的图片包还是资源包
            let isPic = true
            let picArr = { png: 1, jpg: 1, jpeg: 1 }
            item.files.forEach((fileItem) => {
              if (
                !picArr[
                  fileItem.file_name.toLowerCase().split('.')[
                    fileItem.file_name.toLowerCase().split('.').length - 1
                  ]
                ]
              ) {
                isPic = false
              }
            })
            item.isPic = isPic
          }
        })
        this.data = res.data.data.list
        this.total = res.data.data.total
      })
    },
    getIconUrl(url) {
      let typeDict = {
        word: '1',
        doc: '1',
        docx: '1',
        wps: '1',
        ppt: '2',
        pptx: '2',
        pdf: '3',
        mp4: '4',
        png: '5',
        jpg: '5',
        jpeg: '5',
        mp3: '6',
      }
      let downloadIconList = [
        '',
        require('../../images/word.png'),
        require('../../images/ppt.png'),
        require('../../images/pdf.png'),
        require('../../images/mp4.png'),
        require('../../images/pic.png'),
        require('../../images/mp3.png'),
      ]
      let type =
        typeDict[url.split('.')[url.split('.').length - 1].toLowerCase()]
      return downloadIconList[type]
    },
    handleSelectionChange(e) {
      console.log('select', e)
      let delIds = []
      e.forEach((item) => {
        delIds.push(item.id)
      })
      this.delIds = delIds
    },
    toDetail(id) {
      // sessionStorage.removeItem('yey-mineMenuIndex')
      this.$router.push(`bookResource?id=${id}`)
    },
    delRecord(id) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        delDownloadRecord(id).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: '删除记录成功！',
              type: 'success',
            })
            this.getDownloadList()
          }
        })
      })
    },
    toBatchDel() {
      if (this.delIds.length == 0) {
        this.$message({
          message: '请选择需要删除的数据!',
          type: 'warning',
        })
        return
      }
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        delDownloadRecordBatch(this.delIds).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: '删除记录成功！',
              type: 'success',
            })
            this.getDownloadList()
          }
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.my-download {
  padding: 0 20px;
  .top-line {
    display: flex;
    height: 70px;
    padding-left: 10px;
  }
  .top-button {
    display: flex;
    height: 70px;
    align-items: center;
    font-size: 14px;
    color: #27b2fe;
    margin-right: 29px;
    cursor: pointer;
    user-select: none;
  }
  .top-icon {
    width: 20px;
    height: 20px;
    margin-right: 7px;
  }
  .small-button {
    width: 74px;
    height: 24px;
    margin-right: 12px;
    border-radius: 12px;
    border: 1px solid #00aeff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #00aeff;
    user-select: none;
    cursor: pointer;
  }
  .small-button-cancel {
    width: 74px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid #808080;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #808080;
    user-select: none;
    cursor: pointer;
  }
  .file-icon {
    width: 18px;
    height: 18px;
    margin-right: 4px;
  }
}
</style>
